import _createClass from "@babel/runtime/helpers/createClass";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import { RootMetricHelper } from "./RootMetricHelper";
var EYMMetricMethods;
(function (EYMMetricMethods) {
  EYMMetricMethods["addFileExtension"] = "addFileExtension";
  EYMMetricMethods["extLink"] = "extLink";
  EYMMetricMethods["file"] = "file";
  EYMMetricMethods["hit"] = "hit";
  EYMMetricMethods["notBounce"] = "notBounce";
  EYMMetricMethods["params"] = "params";
  EYMMetricMethods["reachGoal"] = "reachGoal";
  EYMMetricMethods["setUserID"] = "setUserID";
  EYMMetricMethods["userParams"] = "userParams";
})(EYMMetricMethods || (EYMMetricMethods = {}));
export var YMMetricHelper = /*#__PURE__*/function (_RootMetricHelper) {
  _inherits(YMMetricHelper, _RootMetricHelper);
  var _super = _createSuper(YMMetricHelper);
  function YMMetricHelper(_ref) {
    var _this;
    var counterId = _ref.counterId,
      isEcommerce = _ref.isEcommerce,
      selector = _ref.selector,
      debug = _ref.debug;
    _classCallCheck(this, YMMetricHelper);
    _this = _super.call(this, {
      selector: selector,
      debug: debug
    });
    _defineProperty(_assertThisInitialized(_this), "counterId", void 0);
    _defineProperty(_assertThisInitialized(_this), "isEcommerce", void 0);
    /* Приватный метод отправки через window.ym (если isEcommerce выключено)
     * НЕ использовать в дочерних классах! */
    _defineProperty(_assertThisInitialized(_this), "sendEvent", function (counterId, eventName) {
      var _window, _window2;
      if (_this.isEcommerce !== false) {
        throw new Error('Счетчик работает на pushEvent');
      }
      if (!Object.values(EYMMetricMethods).includes(eventName)) {
        throw new Error('Неизвестный тип события');
      }
      if (!((_window = window) !== null && _window !== void 0 && _window.ym)) {
        throw new Error('Счётчик не инициализирован');
      }
      // @ts-expect-error - будет ошибка, потому что нет d.ts для global
      for (var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
        args[_key - 2] = arguments[_key];
      }
      (_window2 = window).ym.apply(_window2, [_this.counterId, eventName].concat(args));
    });
    /* Метод отправки через window.dataLayer (если isEcommerce включено) */
    _defineProperty(_assertThisInitialized(_this), "pushEvent", function (params) {
      if (_this.isEcommerce && window) {
        if (_this.isEcommerce === true) {
          var _window$dataLayer;
          // @ts-expect-error - будет ошибка, потому что нет d.ts для global
          (_window$dataLayer = window.dataLayer) === null || _window$dataLayer === void 0 ? void 0 : _window$dataLayer.push(params);
        }
        if (Array.isArray(_this.isEcommerce)) {
          _this.isEcommerce.push(params);
        }
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        if (typeof _this.isEcommerce === 'string' && window[_this.isEcommerce]) {
          // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          // @ts-ignore
          window[_this.isEcommerce].push(params);
        }
      } else {
        throw new Error('Счетчик работает на sendEvent');
      }
    });
    _defineProperty(_assertThisInitialized(_this), "sendFileEvent", function (url, options) {
      _this.sendEvent(_this.counterId, EYMMetricMethods.file, url, options);
    });
    _defineProperty(_assertThisInitialized(_this), "sendHitEvent", function (url, options) {
      _this.sendEvent(_this.counterId, EYMMetricMethods.hit, url, options);
    });
    _defineProperty(_assertThisInitialized(_this), "sendExtLinkEvent", function (url, options) {
      _this.sendEvent(_this.counterId, EYMMetricMethods.extLink, url, options);
    });
    _defineProperty(_assertThisInitialized(_this), "sendNotBounceEvent", function (options) {
      _this.sendEvent(_this.counterId, EYMMetricMethods.notBounce, options);
    });
    /* Метод для отправки yaParams из ТЗ */
    _defineProperty(_assertThisInitialized(_this), "sendParamsEvent", function (params) {
      _this.sendEvent(_this.counterId, EYMMetricMethods.params, params);
    });
    /* Метод для отправки reachGoal через window.ym */
    _defineProperty(_assertThisInitialized(_this), "sendReachGoalEvent", function (target, params, callback, ctx) {
      _this.sendEvent(_this.counterId, EYMMetricMethods.reachGoal, target, params, callback, ctx);
    });
    _defineProperty(_assertThisInitialized(_this), "sendSetUserIDEvent", function (userID) {
      _this.sendEvent(_this.counterId, EYMMetricMethods.setUserID, userID);
    });
    _defineProperty(_assertThisInitialized(_this), "sendUserParamsEvent", function (params) {
      _this.sendEvent(_this.counterId, EYMMetricMethods.userParams, params);
    });
    _defineProperty(_assertThisInitialized(_this), "sendAddFileExtensionEvent", function (extensions) {
      _this.sendEvent(_this.counterId, EYMMetricMethods.addFileExtension, extensions);
    });
    _this.counterId = counterId;
    _this.isEcommerce = isEcommerce;
    return _this;
  }
  return _createClass(YMMetricHelper);
}(RootMetricHelper);

// ==== EXAMPLE CODE ====
// class MyYMMetric extends YMMetricHelper {
//   constructor() {
//     super(123, false);
//   }
//
//   test() {
//     this.pushEvent({ test: 123 });
//   }
// }
//
// const myYMMetric = new MyYMMetric();
//
// myYMMetric.test();